import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { FC, useMemo, useEffect } from "react";
import { AnchorSettinsContainer, ContentWrapper, PickerWrapper, Right, SettingsLabel } from "../styles";
import { AppTester } from "supporting";
import { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { useTranslation } from "react-i18next";
import { AddButton, ProjectEditPageGridLabel } from "shared/pages/projectEdit/styles";
import { Checkbox, DropdownWrapper } from "../PresentatitonBlock";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import { bTag, LayoutConst, useModal } from "core";
import { AnchorType, IAddProjectCoverContent, Tag } from "@brg/api";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { BilingWrapper, ContentAddContainer } from "shared/pages/projectEdit/styles";
import { MAX_PLACES_TAG_COUNT, MAX_TAG_COUNT } from "shared/pages/projectEdit/constants";
import { BTag } from "core/components";
import { isRequired } from "shared/modals/selectTagsModal/support/isRequired";
import { useRouteMatch } from "react-router-dom";

import { LinkTo } from "shared/constants/linkTo";
import { AuthorT } from "shared/pages/projectEdit/types";
import ColorPicker from "../../ColorPicker";
import ViewTypeController from "shared/components/ViewTypeController/ViewTypeController";
import { BilingualSwitcher } from "shared/components/BilingualSwitcher/BilingualSwitcher";
import { useSelector } from "react-redux";
import { BTagsGridNew } from "../../../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { Availability } from "../../Availability/Availability";
import PresentationAuthorsSelect from "shared/pages/projectEdit/fields/Designers/PresentationAuthorsSelect";
import CheckboxField from "shared/pages/projectEdit/fields/CheckboxField";
import TagSelect from "shared/pages/projectEdit/fields/Tags/TagSelect";
import RequiredTagSelect from "shared/pages/projectEdit/fields/Tags/RequiredTagSelect";
import { useController, useFormContext } from "react-hook-form";


interface IProjectSettingProps {
    vTYPE: string;
    additionalContent?: IAddProjectCoverContent;
    currentColor: string;
    proTypeValue: any;
    proTypes: any[];
    requiredTags: Tag[];
    projectTags: Tag[];
    tagEntity?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    hasEducationTag?: boolean;
    tagEntityRequired?: string[];
    isAgeRestricted?: boolean;
    availability?: string;
    isBilingual: boolean;
    isTeamProject?: boolean;
    toggleAgeRestricted?: (e: any) => void;
    onColorChange: (val: string) => void;
    onSetAvailability?: (availability: string) => void;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onAdditionalContentChange?: (data: any) => void;
    onSetPresentationTag: (tag: any) => void;
    onSetRequiredTag: (tag: any) => void;
    onSetProjectTags: (tag: any) => void;
    onCopyLink?: (e: any) => void;
    onBilingualChange: () => void;
}


export const ProjectSettingsBlock: FC<IProjectSettingProps> = ({
    vTYPE,
    additionalContent,
    proTypeValue,
    proTypes,
    tagEntity,
    currentColor,
    requiredTags,
    coAuthors,
    projectTags,
    isBilingual,
    hasEducationTag,
    isAgeRestricted,
    tagEntityRequired,
    contextRequiredTags,
    isTeamProject,
    onColorChange,
    toggleAgeRestricted,
    onCoauthorChange,
    onSetPresentationTag,
    onAdditionalContentChange,
    onSetRequiredTag,
    onSetProjectTags,
    onBilingualChange,
    onCopyLink
}) => {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const isProHSE = AppTester.isProHSE();
    const isHseSpace = AppTester.isHseSpace();
    const isPro = AppTester.isProDeziiign();
    const isSpacePro = AppTester.isContext('s-pro');
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isGeograffee = AppTester.isGeograffee();
    const modal = useModal();
    const toasts = useToasts();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isTeamEdit = useRouteMatch(LinkTo.teamEdit);
    const vtype = useSelector((state: any) => state.vt.vtype);
    const width = window.innerWidth;
    const { anchorLinks } = useSelector(HseContextSelector);
    const { field: {value: availability, onChange: onSetAvailability } } = useController({ name: 'availability' });
    const { setValue, watch } = useFormContext();

    useEffect(() => {
        if (requiredTags && requiredTags.length > 0) {
            setValue('requiredTags', requiredTags, { shouldDirty: false });
        }
    }, []);

    const formRequiredTags = watch('requiredTags');
    useEffect(() => {
        if (formRequiredTags && JSON.stringify(formRequiredTags) !== JSON.stringify(requiredTags)) {
            onSetRequiredTag(formRequiredTags);
        }
    }, [formRequiredTags]);

    const isTransferContext = useMemo(() => vtype && vtype === 'free-type', [vtype])

    const onAnchorSettingsChange = (data: any, field: string) => {
        if (!anchorLinks?.length) {
            toasts.error(t('project_edit.navigation.anchor_empty'))
            return;
        }
        onAdditionalContentChange && onAdditionalContentChange(
            {
                ...(additionalContent ? additionalContent : {}),
                anchors: { ...additionalContent?.anchors, [field]: data, anchorType: AnchorType.popup }
            }
        )
    }



    return (
        <Right vtype={vTYPE}>
            <SettingsLabel>{t('project_edit.project_title')}</SettingsLabel>
            <FlexBox direction='column' directionMobile='column' width={'100%'}>
                {!isTransferContext && (
                    <FlexBox direction="column" directionMobile="column" offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <ProjectEditPageGridLabel fullWidth isTable isTeamEdit style={{ marginBottom: 8 }}>
                            {t('project_edit.project_structure')}
                        </ProjectEditPageGridLabel>
                        <ViewTypeController sizesTypes />
                    </FlexBox>
                )}
                {isTeamProject && (
                    <AnchorSettinsContainer offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <BilingWrapper direction="column" offsetTop={24}>
                            <Checkbox
                                label={t('project_edit.navigation.use_anchor_menu')}
                                checked={!!additionalContent?.anchors?.anchorVisible}
                                dark={!isGeograffee}
                                hintText={t("hints.anchor")}
                                onClick={() => onAnchorSettingsChange(!additionalContent?.anchors?.anchorVisible || false, 'anchorVisible')}
                            />
                        </BilingWrapper>
                    </AnchorSettinsContainer>
                )}
                <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                    <PickerWrapper>
                        <ColorPicker
                            mobileLeftOffset={width < 325 ? 115 : width > 363 ? 180 : 0}
                            value={currentColor}
                            onChange={onColorChange}
                            vTYPE={vTYPE}
                        />
                    </PickerWrapper>
                </FlexBox>
                {isPro && !isMobile && <PresentationAuthorsSelect />}
                {(isPro || isProHSE || isHseSpace) && (
                    <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <CommonInput
                            value={proTypeValue}
                            type={INPUT_TYPES.dropdown}
                            onChange={(option: any) => {
                                onSetPresentationTag(option.value);
                            }}
                            options={proTypes}
                            placeholder={t('teams.adminPage.fields.select_placeholder')}
                            label={t('project_edit.presentation_type')}
                            orientation="column"
                            required
                        />
                    </FlexBox>
                )}

                <div style={{ display: 'inline-flex', marginBottom: isMobile ? 8 : 16, height: 22 }}>
                    <ProjectEditPageGridLabel isPresentation fullWidth style={{ marginRight: is743 ? 4 : 0, marginBottom: 0, paddingTop: 0, whiteSpace: 'nowrap', placeItems: 'center' }}>{t('project_edit.required_tags')}</ProjectEditPageGridLabel>
                    <LabelRedStar style={{ marginLeft: 4, marginTop: is743 ? 2 : 5, marginBottom: 0 }}>*</LabelRedStar>
                </div>
                <FlexBox direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'}>
                    <RequiredTagSelect noLabel />
                </FlexBox>
            </FlexBox>
            <FlexBox direction='column' directionMobile='column' width={'100%'} offsetTop={24} offsetTopMobile={24}>
                <ProjectEditPageGridLabel offsetBottom={16} offsetBottomMobile={16} style={{ paddingTop: 0 }}>{t('project_edit.tags')}</ProjectEditPageGridLabel>
                <FlexBox direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'}>
                    <TagSelect noLabel />
                </FlexBox>
                {!!toggleAgeRestricted && (
                    <BilingWrapper offsetTop={24}>
                        <CheckboxField
                            name="isAgeRestricted"
                            label={t('project_edit.age_restricted')}
                        />
                    </BilingWrapper>
                )}
                {!isTeamEdit && (
                    <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24} direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'} offsetTopMobile={24} offsetTop={24}>
                        <Availability
                            availability={availability ?? ''}
                            onChange={(val) => onSetAvailability(val)}
                            //@ts-ignore
                            onCopy={onCopyLink}
                            hideLabel
                        />
                    </FlexBox>
                )}
                <ContentWrapper disableOffset={!isTeamEdit} offsetTop={isTeamEdit ? 24 : 0} disableRightOffset>
                    <BilingualSwitcher
                        isBilingual={isBilingual}
                        onClick={onBilingualChange}
                        text={t(`bilingual_switcher.presentation_${isBilingual ? 'delete' : 'add'}`)}
                    />
                </ContentWrapper>
            </FlexBox>
        </Right>
    )

}import { CommonInput, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { FC, useMemo, useEffect } from "react";
import { AnchorSettinsContainer, ContentWrapper, PickerWrapper, Right, SettingsLabel } from "../styles";
import { AppTester } from "supporting";
import { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { useTranslation } from "react-i18next";
import { AddButton, ProjectEditPageGridLabel } from "shared/pages/projectEdit/styles";
import { Checkbox, DropdownWrapper } from "../PresentatitonBlock";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import { bTag, LayoutConst, useModal } from "core";
import { AnchorType, IAddProjectCoverContent, Tag } from "@brg/api";
import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { BilingWrapper, ContentAddContainer } from "shared/pages/projectEdit/styles";
import { MAX_PLACES_TAG_COUNT, MAX_TAG_COUNT } from "shared/pages/projectEdit/constants";
import { BTag } from "core/components";
import { isRequired } from "shared/modals/selectTagsModal/support/isRequired";
import { useRouteMatch } from "react-router-dom";

import { LinkTo } from "shared/constants/linkTo";
import { AuthorT } from "shared/pages/projectEdit/types";
import ColorPicker from "../../ColorPicker";
import ViewTypeController from "shared/components/ViewTypeController/ViewTypeController";
import { BilingualSwitcher } from "shared/components/BilingualSwitcher/BilingualSwitcher";
import { useSelector } from "react-redux";
import { BTagsGridNew } from "../../../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { HseContextSelector } from "shared/reducers/hseCurrentContext";
import { Availability } from "../../Availability/Availability";
import PresentationAuthorsSelect from "shared/pages/projectEdit/fields/Designers/PresentationAuthorsSelect";
import CheckboxField from "shared/pages/projectEdit/fields/CheckboxField";
import TagSelect from "shared/pages/projectEdit/fields/Tags/TagSelect";
import RequiredTagSelect from "shared/pages/projectEdit/fields/Tags/RequiredTagSelect";
import { useController, useFormContext } from "react-hook-form";


interface IProjectSettingProps {
    vTYPE: string;
    additionalContent?: IAddProjectCoverContent;
    currentColor: string;
    proTypeValue: any;
    proTypes: any[];
    requiredTags: Tag[];
    projectTags: Tag[];
    tagEntity?: string[];
    coAuthors?: AuthorT[];
    contextRequiredTags?: string[];
    hasEducationTag?: boolean;
    tagEntityRequired?: string[];
    isAgeRestricted?: boolean;
    availability?: string;
    isBilingual: boolean;
    isTeamProject?: boolean;
    toggleAgeRestricted?: (e: any) => void;
    onColorChange: (val: string) => void;
    onSetAvailability?: (availability: string) => void;
    onCoauthorChange?: (data: ProjectAuthorsChangeCbT) => void;
    onAdditionalContentChange?: (data: any) => void;
    onSetPresentationTag: (tag: any) => void;
    onSetRequiredTag: (tag: any) => void;
    onSetProjectTags: (tag: any) => void;
    onCopyLink?: (e: any) => void;
    onBilingualChange: () => void;
}


export const ProjectSettingsBlock: FC<IProjectSettingProps> = ({
    vTYPE,
    additionalContent,
    proTypeValue,
    proTypes,
    tagEntity,
    currentColor,
    requiredTags,
    coAuthors,
    projectTags,
    isBilingual,
    hasEducationTag,
    isAgeRestricted,
    tagEntityRequired,
    contextRequiredTags,
    isTeamProject,
    onColorChange,
    toggleAgeRestricted,
    onCoauthorChange,
    onSetPresentationTag,
    onAdditionalContentChange,
    onSetRequiredTag,
    onSetProjectTags,
    onBilingualChange,
    onCopyLink
}) => {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const isProHSE = AppTester.isProHSE();
    const isHseSpace = AppTester.isHseSpace();
    const isPro = AppTester.isProDeziiign();
    const isSpacePro = AppTester.isContext('s-pro');
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isGeograffee = AppTester.isGeograffee();
    const modal = useModal();
    const toasts = useToasts();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isTeamEdit = useRouteMatch(LinkTo.teamEdit);
    const vtype = useSelector((state: any) => state.vt.vtype);
    const width = window.innerWidth;
    const { anchorLinks } = useSelector(HseContextSelector);
    const { field: {value: availability, onChange: onSetAvailability } } = useController({ name: 'availability' });
    const { setValue, watch } = useFormContext();

    useEffect(() => {
        if (requiredTags && requiredTags.length > 0) {
            setValue('requiredTags', requiredTags, { shouldDirty: false });
        }
    }, []);

    const formRequiredTags = watch('requiredTags');
    useEffect(() => {
        if (formRequiredTags && JSON.stringify(formRequiredTags) !== JSON.stringify(requiredTags)) {
            onSetRequiredTag(formRequiredTags);
        }
    }, [formRequiredTags]);

    const isTransferContext = useMemo(() => vtype && vtype === 'free-type', [vtype])

    const onAnchorSettingsChange = (data: any, field: string) => {
        if (!anchorLinks?.length) {
            toasts.error(t('project_edit.navigation.anchor_empty'))
            return;
        }
        onAdditionalContentChange && onAdditionalContentChange(
            {
                ...(additionalContent ? additionalContent : {}),
                anchors: { ...additionalContent?.anchors, [field]: data, anchorType: AnchorType.popup }
            }
        )
    }



    return (
        <Right vtype={vTYPE}>
            <SettingsLabel>{t('project_edit.project_title')}</SettingsLabel>
            <FlexBox direction='column' directionMobile='column' width={'100%'}>
                {!isTransferContext && (
                    <FlexBox direction="column" directionMobile="column" offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <ProjectEditPageGridLabel fullWidth isTable isTeamEdit style={{ marginBottom: 8 }}>
                            {t('project_edit.project_structure')}
                        </ProjectEditPageGridLabel>
                        <ViewTypeController sizesTypes />
                    </FlexBox>
                )}
                {isTeamProject && (
                    <AnchorSettinsContainer offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <BilingWrapper direction="column" offsetTop={24}>
                            <Checkbox
                                label={t('project_edit.navigation.use_anchor_menu')}
                                checked={!!additionalContent?.anchors?.anchorVisible}
                                dark={!isGeograffee}
                                hintText={t("hints.anchor")}
                                onClick={() => onAnchorSettingsChange(!additionalContent?.anchors?.anchorVisible || false, 'anchorVisible')}
                            />
                        </BilingWrapper>
                    </AnchorSettinsContainer>
                )}
                <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                    <PickerWrapper>
                        <ColorPicker
                            mobileLeftOffset={width < 325 ? 115 : width > 363 ? 180 : 0}
                            value={currentColor}
                            onChange={onColorChange}
                            vTYPE={vTYPE}
                        />
                    </PickerWrapper>
                </FlexBox>
                {isPro && !isMobile && <PresentationAuthorsSelect />}
                {(isPro || isProHSE || isHseSpace) && (
                    <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24}>
                        <CommonInput
                            value={proTypeValue}
                            type={INPUT_TYPES.dropdown}
                            onChange={(option: any) => {
                                onSetPresentationTag(option.value);
                            }}
                            options={proTypes}
                            placeholder={t('teams.adminPage.fields.select_placeholder')}
                            label={t('project_edit.presentation_type')}
                            orientation="column"
                            required
                        />
                    </FlexBox>
                )}

                <div style={{ display: 'inline-flex', marginBottom: isMobile ? 8 : 16, height: 22 }}>
                    <ProjectEditPageGridLabel isPresentation fullWidth style={{ marginRight: is743 ? 4 : 0, marginBottom: 0, paddingTop: 0, whiteSpace: 'nowrap', placeItems: 'center' }}>{t('project_edit.required_tags')}</ProjectEditPageGridLabel>
                    <LabelRedStar style={{ marginLeft: 4, marginTop: is743 ? 2 : 5, marginBottom: 0 }}>*</LabelRedStar>
                </div>
                <FlexBox direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'}>
                    <RequiredTagSelect noLabel />
                </FlexBox>
            </FlexBox>
            <FlexBox direction='column' directionMobile='column' width={'100%'} offsetTop={24} offsetTopMobile={24}>
                <ProjectEditPageGridLabel offsetBottom={16} offsetBottomMobile={16} style={{ paddingTop: 0 }}>{t('project_edit.tags')}</ProjectEditPageGridLabel>
                <FlexBox direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'}>
                    <TagSelect noLabel />
                </FlexBox>
                {!!toggleAgeRestricted && (
                    <BilingWrapper offsetTop={24}>
                        <CheckboxField
                            name="isAgeRestricted"
                            label={t('project_edit.age_restricted')}
                        />
                    </BilingWrapper>
                )}
                {!isTeamEdit && (
                    <FlexBox offsetBottom={24} offsetBottomMobile={is743 ? 32 : 24} direction={'column'} directionMobile='column' width={'100%'} widthMobile={'100%'} offsetTopMobile={24} offsetTop={24}>
                        <Availability
                            availability={availability ?? ''}
                            onChange={(val) => onSetAvailability(val)}
                            //@ts-ignore
                            onCopy={onCopyLink}
                            hideLabel
                        />
                    </FlexBox>
                )}
                <ContentWrapper disableOffset={!isTeamEdit} offsetTop={isTeamEdit ? 24 : 0} disableRightOffset>
                    <BilingualSwitcher
                        isBilingual={isBilingual}
                        onClick={onBilingualChange}
                        text={t(`bilingual_switcher.presentation_${isBilingual ? 'delete' : 'add'}`)}
                    />
                </ContentWrapper>
            </FlexBox>
        </Right>
    )

}